module.exports = __webpack_public_path__ + "img/Orzelec-portrait.77ba20c8.jpg";